import { FREE_FILE_HOSTING_DOMAIN_GATE, PARTITIONING_GATE, PERMISSIONS_GATE } from '../Constants';
const KNOWN_GATES = [FREE_FILE_HOSTING_DOMAIN_GATE, PARTITIONING_GATE, PERMISSIONS_GATE];
export const filterFileManagerSpecificGates = gates => {
  return gates.filter(gateName => gateName.startsWith('FileManager') || gateName.startsWith('DAM:') || KNOWN_GATES.includes(gateName));
};